import React, { useState } from 'react';
import { CameraIcon, RadioIcon, SearchIcon, ListIcon, WifiOffIcon, RefreshCwIcon, CheckCircleIcon, XCircleIcon } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
export function MobileFieldOfficer() {
  const [view, setView] = useState<'home' | 'scan' | 'result'>('home');
  const [isOnline, setIsOnline] = useState(true);
  const [scanResult, setScanResult] = useState<'valid' | 'invalid' | null>(null);
  const activeTrips = [{
    name: 'Rahim Uddin',
    permitId: 'PER-2024-001',
    zone: 'Chandpai Range',
    entryTime: '06:00 AM'
  }, {
    name: 'Karim Sheikh',
    permitId: 'PER-2024-002',
    zone: 'Sarankhola Range',
    entryTime: '05:30 AM'
  }, {
    name: 'Fatema Begum',
    permitId: 'PER-2024-003',
    zone: 'Khulna Range',
    entryTime: '07:15 AM'
  }];
  const handleScan = (type: 'qr' | 'rfid') => {
    setView('scan');
    setTimeout(() => {
      setScanResult(Math.random() > 0.3 ? 'valid' : 'invalid');
      setView('result');
    }, 2000);
  };
  return <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4" data-id="element-1180">
      {/* Mobile Frame */}
      <div className="w-full max-w-sm bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-1181">
        {/* Status Bar */}
        <div className="bg-[#1B5E20] px-6 py-4" data-id="element-1182">
          <div className="flex items-center justify-between text-white" data-id="element-1183">
            <div className="flex items-center gap-2" data-id="element-1184">
              <div className="font-bold text-lg" data-id="element-1185">Sundarban Field App</div>
            </div>
            <div className="flex items-center gap-3" data-id="element-1186">
              <div className="flex items-center gap-1" data-id="element-1187">
                <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-green-400' : 'bg-red-400'}`} data-id="element-1188"></div>
                <span className="text-xs" data-id="element-1189">
                  {isOnline ? 'Online' : 'Offline'}
                </span>
              </div>
              <button onClick={() => setIsOnline(!isOnline)} className="p-1.5 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors" data-id="element-1190">
                <RefreshCwIcon size={16} data-id="element-1191" />
              </button>
            </div>
          </div>
        </div>

        {/* Content Area */}
        <div className="p-6 min-h-[600px]" data-id="element-1192">
          {view === 'home' && <div className="space-y-4" data-id="element-1193">
              <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1194">
                Quick Actions
              </h2>

              {/* Action Cards */}
              <button onClick={() => handleScan('qr')} className="w-full bg-[#1B5E20] text-white rounded-2xl p-6 flex items-center gap-4 hover:bg-[#2E7D32] transition-colors" data-id="element-1195">
                <div className="w-14 h-14 bg-white bg-opacity-20 rounded-xl flex items-center justify-center" data-id="element-1196">
                  <CameraIcon size={28} data-id="element-1197" />
                </div>
                <div className="text-left" data-id="element-1198">
                  <div className="font-bold text-lg" data-id="element-1199">Scan QR Code</div>
                  <div className="text-sm opacity-90" data-id="element-1200">
                    Verify permit entry/exit
                  </div>
                </div>
              </button>

              <button onClick={() => handleScan('rfid')} className="w-full bg-[#2E7D32] text-white rounded-2xl p-6 flex items-center gap-4 hover:bg-[#1B5E20] transition-colors" data-id="element-1201">
                <div className="w-14 h-14 bg-white bg-opacity-20 rounded-xl flex items-center justify-center" data-id="element-1202">
                  <RadioIcon size={28} data-id="element-1203" />
                </div>
                <div className="text-left" data-id="element-1204">
                  <div className="font-bold text-lg" data-id="element-1205">Scan RFID</div>
                  <div className="text-sm opacity-90" data-id="element-1206">Tap card to reader</div>
                </div>
              </button>

              <button onClick={() => setView('home')} className="w-full bg-white border-2 border-gray-300 text-gray-900 rounded-2xl p-6 flex items-center gap-4 hover:bg-gray-50 transition-colors" data-id="element-1207">
                <div className="w-14 h-14 bg-gray-100 rounded-xl flex items-center justify-center" data-id="element-1208">
                  <SearchIcon size={28} data-id="element-1209" />
                </div>
                <div className="text-left" data-id="element-1210">
                  <div className="font-bold text-lg" data-id="element-1211">Verify Permit</div>
                  <div className="text-sm text-gray-600" data-id="element-1212">
                    Manual permit lookup
                  </div>
                </div>
              </button>

              <button onClick={() => setView('home')} className="w-full bg-white border-2 border-gray-300 text-gray-900 rounded-2xl p-6 flex items-center gap-4 hover:bg-gray-50 transition-colors" data-id="element-1213">
                <div className="w-14 h-14 bg-gray-100 rounded-xl flex items-center justify-center" data-id="element-1214">
                  <ListIcon size={28} data-id="element-1215" />
                </div>
                <div className="text-left" data-id="element-1216">
                  <div className="font-bold text-lg" data-id="element-1217">Active Trips</div>
                  <div className="text-sm text-gray-600" data-id="element-1218">
                    {activeTrips.length} trips in progress
                  </div>
                </div>
              </button>

              {!isOnline && <div className="bg-yellow-50 border-2 border-yellow-300 rounded-2xl p-4 flex items-start gap-3" data-id="element-1219">
                  <WifiOffIcon className="text-yellow-600 flex-shrink-0 mt-0.5" size={20} data-id="element-1220" />
                  <div className="text-sm" data-id="element-1221">
                    <div className="font-semibold text-yellow-900" data-id="element-1222">
                      Working Offline
                    </div>
                    <div className="text-yellow-700 mt-1" data-id="element-1223">
                      Data will sync when connected
                    </div>
                    <button className="mt-2 text-yellow-900 font-medium underline" data-id="element-1224">
                      3 pending syncs
                    </button>
                  </div>
                </div>}
            </div>}

          {view === 'scan' && <div className="flex flex-col items-center justify-center h-full" data-id="element-1225">
              <div className="w-64 h-64 border-4 border-[#1B5E20] rounded-2xl flex items-center justify-center mb-6 relative overflow-hidden" data-id="element-1226">
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#1B5E20] to-transparent opacity-20 animate-pulse" data-id="element-1227"></div>
                <CameraIcon size={64} className="text-gray-400" data-id="element-1228" />
              </div>
              <div className="text-center" data-id="element-1229">
                <div className="font-bold text-lg text-gray-900 mb-2" data-id="element-1230">
                  Scanning...
                </div>
                <div className="text-sm text-gray-600" data-id="element-1231">
                  Position QR code within frame
                </div>
              </div>
            </div>}

          {view === 'result' && scanResult && <div className="space-y-6" data-id="element-1232">
              <div className={`rounded-2xl p-6 ${scanResult === 'valid' ? 'bg-green-50 border-2 border-green-500' : 'bg-red-50 border-2 border-red-500'}`} data-id="element-1233">
                <div className="flex items-start gap-4" data-id="element-1234">
                  {scanResult === 'valid' ? <CheckCircleIcon className="text-green-600 flex-shrink-0" size={48} data-id="element-1235" /> : <XCircleIcon className="text-red-600 flex-shrink-0" size={48} data-id="element-1236" />}
                  <div className="flex-1" data-id="element-1237">
                    <h3 className={`text-2xl font-bold mb-2 ${scanResult === 'valid' ? 'text-green-900' : 'text-red-900'}`} data-id="element-1238">
                      {scanResult === 'valid' ? 'Valid Permit' : 'Invalid Permit'}
                    </h3>
                    {scanResult === 'valid' ? <div className="space-y-3" data-id="element-1239">
                        <div className="flex items-center justify-center w-20 h-20 bg-gray-300 rounded-full text-3xl mx-auto mb-3" data-id="element-1240">
                          👤
                        </div>
                        <div className="space-y-2 text-sm text-green-900" data-id="element-1241">
                          <div data-id="element-1242">
                            <span className="font-semibold" data-id="element-1243">Name:</span> Rahim
                            Uddin
                          </div>
                          <div data-id="element-1244">
                            <span className="font-semibold" data-id="element-1245">Permit ID:</span>{' '}
                            PER-2024-001
                          </div>
                          <div data-id="element-1246">
                            <span className="font-semibold" data-id="element-1247">Type:</span> Fishing
                          </div>
                          <div data-id="element-1248">
                            <span className="font-semibold" data-id="element-1249">Zone:</span>{' '}
                            Chandpai Range
                          </div>
                          <div data-id="element-1250">
                            <span className="font-semibold" data-id="element-1251">Valid Until:</span>{' '}
                            2024-04-05
                          </div>
                          <div data-id="element-1252">
                            <span className="font-semibold" data-id="element-1253">Vessel:</span>{' '}
                            Boat-123
                          </div>
                          <div className="pt-2" data-id="element-1254">
                            <StatusBadge status="active" data-id="element-1255" />
                          </div>
                        </div>
                      </div> : <div className="text-sm text-red-900" data-id="element-1256">
                        <div className="font-semibold mb-2" data-id="element-1257">
                          Reason: Permit Expired
                        </div>
                        <div data-id="element-1258">
                          This permit expired on 2024-03-20. Entry denied.
                        </div>
                        <div className="mt-3 font-semibold" data-id="element-1259">
                          Action: Contact station officer
                        </div>
                      </div>}
                  </div>
                </div>
              </div>

              <button onClick={() => {
            setView('home');
            setScanResult(null);
          }} className="w-full py-4 bg-[#1B5E20] text-white rounded-xl font-semibold hover:bg-[#2E7D32] transition-colors" data-id="element-1260">
                Done
              </button>
            </div>}
        </div>

        {/* Bottom Navigation */}
        <div className="border-t border-gray-200 px-6 py-4 bg-white" data-id="element-1261">
          <div className="flex justify-around" data-id="element-1262">
            <button className="flex flex-col items-center gap-1 text-[#1B5E20]" data-id="element-1263">
              <CameraIcon size={24} data-id="element-1264" />
              <span className="text-xs font-medium" data-id="element-1265">Scan</span>
            </button>
            <button className="flex flex-col items-center gap-1 text-gray-400" data-id="element-1266">
              <ListIcon size={24} data-id="element-1267" />
              <span className="text-xs font-medium" data-id="element-1268">Trips</span>
            </button>
            <button className="flex flex-col items-center gap-1 text-gray-400" data-id="element-1269">
              <SearchIcon size={24} data-id="element-1270" />
              <span className="text-xs font-medium" data-id="element-1271">Search</span>
            </button>
          </div>
        </div>
      </div>
    </div>;
}